import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../components/Hero";
import OurOffering from "../components/OurOffering";
import LoanTypes from "../components/LoanTypes";
import LoanDetails from "../components/LoanDetails";
import FlexibleFinance from "../components/FlexibleFinance";
import WhyChoose from "../components/WhyChoose";
import FinanceVideoSection from "../components/FinanceVideoSection";
import OurService from "../components/OurService";
import FAQSection from "../components/FAQsection";

import EMICalculator from "../components/EMICalculator";
import WhatsAppButton from "../components/WhatsAppButton";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      requestAnimationFrame(() => {
        const id = location.hash.substring(1);
        const el = document.getElementById(id);
        if (el) {
          const yOffset = -100; // adjust for your header height
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      });
    }
  }, [location]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f8ff] w-full">
      <HeroSection />
      <OurOffering />
      <LoanTypes />
      {/* <section id="loan"><LoanDetails /></section> */}
      <LoanDetails />
      <FlexibleFinance />
      <WhyChoose />

      <FinanceVideoSection/>
      <OurService/>
      <FAQSection />
      <EMICalculator/>
      <WhatsAppButton/>
    </div>
  );
}

export default Home;
